import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login-register-modal',
  templateUrl: './login-register-modal.component.html',
  styleUrls: ['./login-register-modal.component.css']
})
export class LoginRegisterModalComponent implements OnInit {

  title = "Login"
  error = false
  successMailSent = false
  errorMessage = ''
  mailSentMessage = ''
  loginForm : FormGroup
  registerForm : FormGroup
  forgotPasswordForm : FormGroup

  constructor(private fb : FormBuilder, private authService : AuthService, private common : CommonService, private router : Router) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      identifier: ["", [Validators.email, Validators.required]],
      password: ["", [Validators.required]]
    })
    this.registerForm = this.fb.group({
      username: ["", [Validators.required]],
      email: ["", [Validators.email, Validators.required]],
      password: ["", [Validators.required]],
      referrer: [""]
    })
    this.forgotPasswordForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]]
    })
  }

  login(){
    
    this.common.showLoader()
    // console.log(this.loginForm.value)
    this.authService.Login(this.loginForm.value).subscribe((res:any)=>{
      this.common.hideLoader()
      if(res.jwt){
        // alert("login success")
        localStorage.setItem("res", JSON.stringify(res))
        document.getElementById("closeLoginRegisterModal").click()
        this.router.navigateByUrl('/dashboard')
      }
      else{
        console.log(res.message[0].messages[0].message)
      }
    }, (err:any)=>{
      this.common.hideLoader()
      this.error = true
      this.errorMessage = err.error.message[0].messages[0].message
      console.log(err.error.message[0].messages[0].message)
    })
  }

  register(){
    this.common.showLoader()
    console.log(this.registerForm.value)
    this.authService.Register(this.registerForm.value).subscribe((res:any)=>{
      this.common.hideLoader()
      if(res.user){
        this.registerForm.reset()
        this.error = false
        this.errorMessage = ''
        this.successMailSent = true
        this.mailSentMessage = 'A verification mail has been sent to your email address, kindly click on the link to verify your account.'
      }
      else{
        console.log(res.message[0].messages[0].message)
      }
    }, (err:any)=>{
      this.common.hideLoader()
      this.error = true
      this.errorMessage = err.error.message[0].messages[0].message
      console.log(err.error.message[0].messages[0].message)
    })
  }

  forgotPassword(){
    this.common.showLoader()
    console.log(this.forgotPasswordForm.value)
    this.authService.ForgotPassword(this.forgotPasswordForm.value).subscribe((res:any)=>{
      this.common.hideLoader()
      if(res.ok){
        this.forgotPasswordForm.reset()
        this.error = false
        this.errorMessage = ''
        this.successMailSent = true
        this.mailSentMessage = 'A link to reset your password has been sent to your mail, kindly click on the link to reset your password.'
      }
      else{
        console.log(res.message[0]?.messages[0]?.message)
      }
    }, (err:any)=>{
      this.common.hideLoader()
      this.error = true
      this.errorMessage = err.error?.message[0]?.messages[0]?.message
      console.log(err.error?.message[0]?.messages[0]?.message)
    })
  }

  toggle(title){
    this.title = title
    this.error = false
    this.successMailSent = false
    this.errorMessage = ''
    this.mailSentMessage = ''
    this.forgotPasswordForm.reset()
    this.loginForm.reset()
    this.registerForm.reset()
  }

  clearError(){
    this.errorMessage = ''
    this.error = false
  }

  get formControl() {
    return this.loginForm.controls;
  }

}


// {
//   "statusCode": 400,
//   "error": "Bad Request",
//   "message": [
//       {
//           "messages": [
//               {
//                   "id": "Auth.form.error.email.taken",
//                   "message": "Email is already taken."
//               }
//           ]
//       }
//   ],
//   "data": [
//       {
//           "messages": [
//               {
//                   "id": "Auth.form.error.email.taken",
//                   "message": "Email is already taken."
//               }
//           ]
//       }
//   ]
// }

// {
//   "jwt": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NSwiaWF0IjoxNjM2MjAzMDkxLCJleHAiOjE2Mzg3OTUwOTF9.uoXRKFEQz2umGXQs-iwEobKM9OnwTBPtpkAvEi_1umM",
//   "user": {
//       "id": 5,
//       "username": "pd",
//       "email": "paras@gkmit.co",
//       "provider": "local",
//       "confirmed": true,
//       "blocked": false,
//       "role": {
//           "id": 1,
//           "name": "Authenticated",
//           "description": "Default role given to authenticated user.",
//           "type": "authenticated"
//       },
//       "created_at": "2021-11-06T12:51:31.398Z",
//       "updated_at": "2021-11-06T12:51:31.412Z"
//   }
// }